import { classNames } from "../../classNames";

/** What the table body shows, in order of precedence. */
export type BodyState = "loading" | "error" | "empty" | "noResults" | "rows";

export interface BodyFacts {
  loading: boolean;
  failed: boolean;
  /** Rows before search and filters. */
  rowCount: number;
  /** Rows on the current page after search and filters. */
  pageRowCount: number;
}

export function bodyState({ loading, failed, rowCount, pageRowCount }: BodyFacts): BodyState {
  if (loading) return "loading";
  if (failed) return "error";
  if (rowCount === 0) return "empty";
  if (pageRowCount === 0) return "noResults";
  return "rows";
}

/** How a row responds to the user. */
export interface RowLook {
  expandable: boolean;
  clickable: boolean;
  open: boolean;
}

/** `is-expandable` wins over `is-clickable`; `is-open` marks an expanded row. */
export function rowClassName({ expandable, clickable, open }: RowLook): string | undefined {
  return classNames(expandable ? "is-expandable" : clickable && "is-clickable", open && "is-open") || undefined;
}

/** A copy of `keys` with `key` added, or removed when it was already there. */
export function toggleKey(keys: ReadonlySet<string>, key: string): Set<string> {
  const next = new Set(keys);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  return next;
}
